/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Cancellation_Scheduled_TitleInputs */

const fr_membership_cancellation_scheduled_title = /** @type {(inputs: Membership_Cancellation_Scheduled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résiliation programmée`)
};

/**

* @param {Membership_Cancellation_Scheduled_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_cancellation_scheduled_title = /** @type {((inputs?: Membership_Cancellation_Scheduled_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Cancellation_Scheduled_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_cancellation_scheduled_title(inputs)
});